import {
  GET_PRACTICE_REPORT_REQUESTED,
  GET_PRACTICE_REPORT_SEARCH,
  EMPTY_PRACTICE_REPORT_SEARCH,
  CLEAR_PRACTICE_REPORT,
} from '../constants/constant.action'

export function getPracticeReportList(carePointObj) {
  return {
    type: GET_PRACTICE_REPORT_REQUESTED,
    payload: carePointObj,
  }
}

export function getPracticeReportSearch(value) {
  return {
    type: GET_PRACTICE_REPORT_SEARCH,
    payload: value,
  }
}

export function emptyPracticeReportSearch() {
  return {
    type: EMPTY_PRACTICE_REPORT_SEARCH,
    payload: '',
  }
}

export function clearPracticeReport() {
  return {
    type: CLEAR_PRACTICE_REPORT,
  }
}
